import type { SVGProps } from 'react';

const IconAddOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12.0002 8.66665H8.66683V12C8.66683 12.3666 8.36683 12.6666 8.00016 12.6666C7.6335 12.6666 7.3335 12.3666 7.3335 12V8.66665H4.00016C3.6335 8.66665 3.3335 8.36665 3.3335 7.99998C3.3335 7.63331 3.6335 7.33331 4.00016 7.33331H7.3335V3.99998C7.3335 3.63331 7.6335 3.33331 8.00016 3.33331C8.36683 3.33331 8.66683 3.63331 8.66683 3.99998V7.33331H12.0002C12.3668 7.33331 12.6668 7.63331 12.6668 7.99998C12.6668 8.36665 12.3668 8.66665 12.0002 8.66665Z" />
  </svg>
);

export default IconAddOutline;
